module.exports = __webpack_public_path__ + "assets/icon_arrows.e7dbab5b.svg";